define('components/photoset/item/states', [], function () {
    return {
        justCreated: 0,
        pending: 1,
        active: 2
    };
});